import { render, staticRenderFns } from "./EFiltrosDePreMatriculas.vue?vue&type=template&id=0189123f"
import script from "./EFiltrosDePreMatriculas.vue?vue&type=script&lang=js"
export * from "./EFiltrosDePreMatriculas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports